<!--列表查看视图-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="ai-trust-from-window"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.AssociationBusinessInformation')"
    :close-on-click-modal="true"
    @close="innerVisible=false"
  >
    <div class="main-content">
      <div v-if="showRevokeButton" style="padding-bottom: 5px"><el-button no="revoke" type="danger" @click="revokeJobHandler">{{ $t('CargoMsg.Cargo_WithdrawTheEntrustment') }}</el-button></div>
      <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
        <span class="lab-state">{{ labState }}</span>
        <el-tabs ref="tabs" v-model="activeTabName" type="card" @tab-click="handleTabClick">
          <el-tab-pane v-if="currentRow && currentRow.containerLoadType === 'TT'" name="tabGatheringTrailerBase" :label="$t('SeaExport.Basic')">
            <!-- 集卡拖车基础-->
            <tab-gathering-trailer-base ref="tabGatheringTrailerBase" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && currentRow.containerLoadType === 'CL'" name="tabLessThanCarloadBase" :label="$t('SeaExport.Basic')">
            <!--   整车/零担基础-->
            <tab-less-than-carload-base ref="tabLessThanCarloadBase" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && !currentRow.masterFlag && currentRow.containerLoadType === 'IC'" name="tabInternationalCard" :label="$t('CargoMsg.Cargo_IC')">
            <!-- 国际卡航-基本-->
            <tab-international-card-base ref="tabInternationalCard" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && currentRow.containerLoadType === 'IC'" name="tabOrderCar" :label="$t('CargoMsg.Cargo_Booking')">
            <!-- 国际卡航-订舱-->
            <tab-order-car ref="tabOrderCar" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && currentRow.containerLoadType === 'TT'" name="tabGatheringTrailer" :label="$t('SeaExport.GatheringTrailer')">
            <!-- 集卡拖车-->
            <tab-gathering-trailer ref="tabGatheringTrailer" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && currentRow.containerLoadType === 'CL'" name="tabLessThanCarload" :label="$t('SeaExport.WholeVehicleLessThanCarload')">
            <!-- 整车/零担-->
            <tab-less-than-carload ref="tabLessThanCarload" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-permission="['tab_IEBooking_portalState']" name="tabSopState" :label="$t('SeaExport.BusinessStatus')">
            <tab-sop-state ref="tabSopState" :context="context" :action="action" :show-button="showButton" />
          </el-tab-pane>
          <el-tab-pane name="tabFileHistory" :label="$t('SeaExport.FileHistory')">
            <tab-file-history ref="tabFileHistory" :context="context" :action="action" :show-button="showButton" :can-operate-job="canOperateJob" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import { BookingWorkspaceContext } from '@/views/cargo/v0/Integrated/components/booking/bookingWorkspaceContext'
import { revokeJobFunc } from '@/api/booking/job'
import tabGatheringTrailerBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailerBase'
import tabLessThanCarloadBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarloadBase'
import TabOrderCar from '@/views/cargo/v0/Integrated/components/booking/tabs/tabOrderCar'
import TabGatheringTrailer from '@/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailer'
import TabLessThanCarload from '@/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarload'
import TabInternationalCardBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBase.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'IeTrustFromWindow',
  components: {
    TabInternationalCardBase,
    TabLessThanCarload,
    TabGatheringTrailer,
    TabOrderCar,
    tabLessThanCarloadBase,
    tabGatheringTrailerBase,
    tabSopState,
    tabFileHistory
  },
  props: {
    visible: { type: Boolean, required: true },
    trustJob: { type: Object, required: false, default: null },
    job: { type: Object, required: false, default: null },
    canOperateJob: { type: Boolean, default: true }
  },
  data() {
    return {
      context: new BookingWorkspaceContext(),
      showButton: false,
      innerVisible: false,
      action: 'look',
      currentRow: {},
      activeTabName: 'tabSopState',
      labState: '',
      showRevokeButton: false
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      const loading = getLoading4Cxt()
      this.innerVisible = true
      this.$logger.log('trustJob', this.trustJob)
      await cache.load(cacheName.CONFIG)
      await this.context.prepareData()
      await this.showDetail(this.trustJob)
      loading.close()
    }
  },
  methods: {
    async showDetail(trustJob) {
      this.currentRow = trustJob
      this.currentRow.path = ''
      if (this.currentRow && this.currentRow.containerLoadType) {
        if (this.currentRow.containerLoadType === 'TT') {
          this.activeTabName = 'tabGatheringTrailerBase'
        } else if (this.currentRow.containerLoadType === 'IC') {
          this.activeTabName = 'tabInternationalCard'
        } else if (this.currentRow.containerLoadType === 'CL') {
          this.activeTabName = 'tabLessThanCarloadBase'
        }
      }
      this.labState = this.$t('SeaExport.BusinessStatus') + '：' + ColumnUtils.getJobStateCN(this.currentRow.jobState)
      // 待审核中
      this.showRevokeButton = false
      if (this.currentRow.jobState === -1 && this.job && this.job.lob === this.currentRow.lob) {
        this.showRevokeButton = true
      }
      // CARGO-46261 当参数“ToExoSystem”=JYD时委托逻辑调整
      this.isJyd = String(cache.config.get('ToExoSystem')) === 'JYD'
      if (this.isJyd && this.job.lob === this.currentRow.lob) {
        this.currentRow.userDefinedField1 = ''
        this.currentRow.userDefinedField2 = ''
        this.currentRow.userDefinedField3 = ''
        this.currentRow.userDefinedField4 = ''
      }
      this.handleTabClick()
    },
    revokeJobHandler() {
      if (this.job) {
        const loading = getLoading()
        const obj = {
          uuid: this.job.uuid
        }
        revokeJobFunc(obj).then(res => {
          if (res.data === 'ok') {
            this.$message.success(this.$t('CargoMsg.Cargo_RevokedSuccessfully'))
            this.innerVisible = false
            this.$emit('refresh')
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_checkData1'))
          }
        }).finally(() => {
          loading.close()
        })
      }
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow(this.currentRow, true)
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog.ai-trust-from-window {
  display: flex;
  height: 600px;
  width: 1415px;
  flex-direction: column;
  .el-dialog {
    &__body {
      position: relative;
      display: flex;
      overflow: hidden;
    }
  }
  &.isfullScreen {
    overflow: hidden;
  }
  .el-tabs {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 560px;
    &__content {
      overflow: scroll;
    }
  }
  .lab-state {
    position: absolute;
    z-index: 999;
    right: 30%;
  }
  .tabs-container.cannot-operate-job {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
    .sop-img {
      pointer-events: none;
    }
  }
}
</style>
